module.exports = __webpack_public_path__ + "assets/25e601d0a2627f9d653d41410b891d3b.mp3";